let crypto = require('crypto');

export function md5Sign(data) {
    //参数进行ASCII排序后进行字符串拼接 参数字符串+时间戳+盐
    let SALT = 'akjsdfakjdfbiasjdfbiksj'
    data = encodeURIComponent(data + SALT)
    //处理不被encodeURIComponent编码的字符
    data = data.replace(/\(/g,"%28");
    data = data.replace(/\)/g,"%29");
    data = data.replace(/%20/g,"+");
    // console.log("data",data)
    // 加入字符编码
    var md5 = crypto.createHash('md5').update(data, 'utf-8').digest('hex');
    return md5;
}


export function sorterParamsStr (inObject) {
    let str = "";
    var sortedJson = {}
    var sortedKeys = Object.keys(inObject).sort()
    for (var i = 0; i < sortedKeys.length; i++) {
        sortedJson[sortedKeys[i]] = inObject[sortedKeys[i]]
    }
    let arr = [];
    for(let key in sortedJson){
        if(!(sortedJson[key] == null)){
            arr.push(key + "=" + sortedJson[key]);
            // console.log(key + "=" +sortedJson[key])
        }
    }
    str = arr.join("&");
    return str;
}
